var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5.5C2 4.94772 2.52558 4.5 3.17391 4.5H18.8261C19.4744 4.5 20 4.94772 20 5.5C20 6.05228 19.4744 6.5 18.8261 6.5H3.17391C2.52558 6.5 2 6.05228 2 5.5Z",
    fill: "#F1F1F1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11.5C2 10.9477 2.52558 10.5 3.17391 10.5H18.8261C19.4744 10.5 20 10.9477 20 11.5C20 12.0523 19.4744 12.5 18.8261 12.5H3.17391C2.52558 12.5 2 12.0523 2 11.5Z",
    fill: "#F1F1F1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 17.5C2 16.9477 2.52558 16.5 3.17391 16.5H18.8261C19.4744 16.5 20 16.9477 20 17.5C20 18.0523 19.4744 18.5 18.8261 18.5H3.17391C2.52558 18.5 2 18.0523 2 17.5Z",
    fill: "#F1F1F1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenu);
export default __webpack_public_path__ + "static/media/menu.b8eb9a8f6368be83f61d0aa9a17238da.svg";
export { ForwardRef as ReactComponent };